import React from 'react';
import { motion } from 'framer-motion';

function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-primary z-50 flex items-center justify-center">
      <div className="relative">
        <motion.div
          className="w-24 h-24 rounded-full border-4 border-secondary/30"
          animate={{
            rotate: 360
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "linear"
          }}
        />
        <motion.div
          className="absolute inset-0 border-t-4 border-secondary rounded-full"
          animate={{
            rotate: [0, 720]
          }}
          transition={{
            duration: 2.5,
            repeat: Infinity,
            ease: "linear"
          }}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-2xl font-bold bg-gradient-to-r from-secondary to-secondary-light bg-clip-text text-transparent">
            NS
          </span>
        </div>
      </div>
    </div>
  );
}

export default LoadingScreen; 